import React, {useState, useEffect} from "react";
import {instance} from "../../config/axios-cnf";
import SelectField from "../SelectField";


const ConnectionField = (props) => {

    let [subject, setSubject] = useState([]);
    let [loading, setLoading] = useState(true);

    useEffect(() => apiGetConnection((data) => {
        let array = [];
        data.map(item => {
            array.push({
                label: item.name,
                value: item.id
            });
        })
        if(array.length === 1){

        }
        setSubject(array);
        setLoading(false)

    }, err => {

    }), [])


    return (
        <SelectField
            {...props}
            disabled={loading}
            options={subject}
            isMandatory={!!props.validate}
            isMulti={props.isMulti}
        />
    )
}

export const apiGetConnection = (callback, error) => {
    instance.get('/api/v2/connections')
        .then(response => callback(response.data))
}

export default ConnectionField
